import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import {
  DATABRIDGE_SESSION_QUERY,
  DATABRIDGE_USER_INFO_QUERY,
} from './operations';
import GladlyChatBlock from '../GladlyChatBlock/GladlyChatBlock';
import { analytics } from '../../tools/analytics';

const setUserInDatabridge = ({ userInfo }) => {
  if (!window.digitalData) return;

  const {
    id, hashedEmail, jwtToken, registrationDate,
  } = userInfo;

  const user = {
    id,
    hashedEmail,
    jwtToken,
    registrationDate: registrationDate?.formattedRegistrationDate,
  };

  window.digitalData.merge('user', user);
  analytics.user.setData({
    id,
    hashedEmail,
  });
};

export default function CustomerDatabridge() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const onSessionQueryCompleted = ({ userState }) => setIsLoggedIn(userState?.isLoggedIn);

  useQuery(DATABRIDGE_SESSION_QUERY, {
    ssr: false,
    context: { batch: true },
    onCompleted: onSessionQueryCompleted,
  });

  useQuery(DATABRIDGE_USER_INFO_QUERY, {
    skip: !isLoggedIn,
    ssr: false,
    context: { batch: true },
    refetchPolicy: 'network-only',
    onCompleted: setUserInDatabridge,
  });

  // Note: we should move this to an independent client. Seperate concerns
  // from the rest of this component
  return (
    <GladlyChatBlock appId="abercrombie.com" />
  );
}
